<template>
  <div class="task taskWaitingProcess"></div>
</template>

<script>
import * as api from '../../utils/definitionApi'
import language from '../../language'

export default {
  name: 'definition-task-waiting-process',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'newEval',
    'language',
    'authorization',
    'type',
    'editRepeatableWaitProcess',
    'callTask'
  ],
  data () {
    return {
      processOK: false
    }
  },
  methods: {
    callTaskService () {
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode }})
        .then(resp => {
          if (resp.requestResult) {
            this.processOK = true
          } else {
            this.processOK = false
          }
          this.$emit('waitingProcessFinished', this.processOK, this.repeatableGroupCode)
        })
        .catch(err => {
          console.log(err)
          this.processOK = false
          this.$emit('waitingProcessFinished', this.processOK, this.repeatableGroupCode)
        })
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  watch: {
    editRepeatableWaitProcess (value) {
      if (value) {
        this.$emit('waitingProcessInit')
        this.callTaskService()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
